import http from '@/http'
const URL = '/admin/settings/filters'

export const filters = (context) => http.get(URL + `/${context}`)

export const listColumns = async (params) => {
  const list = (await http.get(URL + '/columns', { params: params }))
  return list
}

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}/open`))
  }
  return one.data
}

export const save = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}
export const deleteC = async (id) => http.delete(URL + `/${id}`)
export const orderList = async (payload) => http.put(URL + `/sequence`, payload)

export const getAvailableFields = (context = 'participants') =>
  http.get(URL + '/available-fields', { params: { context } })

export const syncFilters = (context, fields) =>
  http.post(URL + '/sync', { context, fields })

export default {
  list,
  filters,
  listColumns,
  show,
  save,
  deleteC,
  orderList,
  getAvailableFields,
  syncFilters
}
